import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const HeaderNavAction = ({ surface, className, children, active, ...rest }) => {
  return (
    <button
      type="button"
      className={classNames(
        'HeaderNavAction',
        'nav-link',
        `HeaderNavAction--${surface}`,
        className,
        { active }
      )}
      {...rest}
    >
      {children}
    </button>
  );
};

HeaderNavAction.propTypes = {
  surface: PropTypes.oneOf(['top', 'bottom']).isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  active: PropTypes.bool,
};

HeaderNavAction.defaultProps = {
  className: '',
  children: null,
  active: false,
};

export default HeaderNavAction;
